import { z } from "zod";

// 读回来必须校验：内容可能是旧版本挂件写的，也可能被店面脚本改过。
const viewStateSchema = z.object({
  /** 手机抽屉离开时的档位；peek 表示停在窥视条。 */
  drawer: z
    .object({ snap: z.number().int().min(0).max(2), peek: z.boolean() })
    .optional(),
  /** 离开时输入框有焦点才有：桌面端回来恢复焦点和光标。 */
  composer: z
    .object({ start: z.number().int().min(0), end: z.number().int().min(0) })
    .optional(),
});

export type WidgetViewState = z.infer<typeof viewStateSchema>;

/** 换页、刷新后要接着用的界面状态（设计稿 12a）。会话本身在 Conversation 快照里，这里只放界面的。 */
export interface WidgetView {
  /** 挂载时读到的上一页状态。 */
  initial: WidgetViewState;
  save: (patch: WidgetViewState) => void;
}

export function createWidgetView(shopDomain: string): WidgetView {
  const key = `gonovus:view:${shopDomain}`;
  let state: WidgetViewState = {};
  try {
    const parsed = viewStateSchema.safeParse(
      JSON.parse(sessionStorage.getItem(key) ?? "null"),
    );
    if (parsed.success) state = parsed.data;
  } catch {
    /* 禁用存储时只是不恢复界面状态。 */
  }
  return {
    initial: state,
    save(patch) {
      state = { ...state, ...patch };
      try {
        sessionStorage.setItem(key, JSON.stringify(state));
      } catch {
        /* 隐私模式或配额耗尽不能影响店面。 */
      }
    },
  };
}
